import { cn } from '@goaltree/ui/lib/utils'

// Karaoke transcript: the full text is shown and each word highlights as it's
// spoken — bright once voiced, dimmed ahead, current word emphasized. `chars` is
// how many characters have been voiced so far. Paragraphs split on blank lines
// (like the markdown view); char offsets advance through separators so the
// highlight stays aligned with `chars`.
export function SpokenText({
  text,
  chars,
  currentRef,
  highlight,
  className = 'text-sm leading-relaxed',
}: {
  text: string
  chars: number
  currentRef?: React.RefObject<HTMLSpanElement | null>
  // Current-word pill colour; defaults to the accent.
  highlight?: string
  className?: string
}) {
  let pos = 0
  let paraIdx = 0
  const segments = text.split(/(\n{2,})/)
  return (
    <div className={className}>
      {segments.map((seg, si) => {
        if (seg === '') return null
        if (/^\n{2,}$/.test(seg)) {
          pos += seg.length
          return null
        }
        const parts = seg.split(/(\s+)/)
        const el = (
          <p key={si} className={cn('whitespace-pre-wrap', paraIdx > 0 && 'mt-3')}>
            {parts.map((part, i) => {
              const start = pos
              pos += part.length
              const end = pos
              if (!part.trim()) return <span key={i}>{part}</span>
              const current = start < chars && chars <= end
              return (
                <span
                  key={i}
                  ref={current ? currentRef : undefined}
                  style={current && highlight ? { backgroundColor: `${highlight}38` } : undefined}
                  className={cn(
                    'transition-colors duration-150',
                    current
                      ? cn('rounded text-foreground', !highlight && 'bg-primary/20')
                      : start < chars
                        ? 'text-foreground'
                        : 'text-foreground/40',
                  )}
                >
                  {part}
                </span>
              )
            })}
          </p>
        )
        paraIdx++
        return el
      })}
    </div>
  )
}
